import moment from "moment";

export const formatDate = (dateISO: string) => {
  return moment(dateISO).format("DD/MM/YYYY");
};

// Returns the current time rounded up to the next 5-minute mark
// (e.g. 20:31 -> 20:35, 20:35 -> 20:35). Used to pre-fill scheduling pickers
// so the time never defaults to 00:00.
export const nextFiveMinutes = (): moment.Moment => {
  const now = moment()
    .seconds(0)
    .milliseconds(0);
  const remainder = now.minute() % 5;
  return remainder === 0 ? now : now.add(5 - remainder, "minutes");
};

// Working day starts at 08:00: the time a scheduling picker falls back to when
// the doctor moves to a day other than today.
export const DEFAULT_SCHEDULE_HOUR = 8;

// Resolves the value a scheduling picker should take when it changes.
// Picking a different day resets the time (08:00, or the next 5-minute mark if
// the day is today) instead of carrying over the time from the previous day;
// changing only the time on the same day is left untouched.
export const resolveScheduledDateTime = (
  previous: moment.Moment | null,
  next: moment.Moment | null
): moment.Moment | null => {
  if (!next || (previous && next.isSame(previous, "day"))) return next;
  if (next.isSame(moment(), "day")) return nextFiveMinutes();
  return next
    .clone()
    .hour(DEFAULT_SCHEDULE_HOUR)
    .minute(0)
    .seconds(0)
    .milliseconds(0);
};
